import { render, staticRenderFns } from "./publishHistory.vue?vue&type=template&id=32701f18"
import script from "./publishHistory.vue?vue&type=script&lang=js"
export * from "./publishHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports